module.exports = __webpack_public_path__ + "img/Logo-BlackWhite.52317565.png";